import { NextPage } from 'next'

// Meta Tags
import MetaTags from '@/components/common/meta-tags'

// BreadCrumb
import BreadCrumb from '@/components/common/breadcrumb'

// Component
import OurServicesSection from '@/components/page-components/services-page'

const ServicesPage: NextPage = () => {
  return (
    <>
      <MetaTags title="Services | Comfort - The Home Craft" />

      <BreadCrumb pageName="Services" />

      <OurServicesSection />
    </>
  )
}

export default ServicesPage
